import { render } from "./FeedCardFrame.vue?vue&type=template&id=4e560f5c&scoped=true"
import script from "./FeedCardFrame.vue?vue&type=script&lang=js"
export * from "./FeedCardFrame.vue?vue&type=script&lang=js"

import "./FeedCardFrame.vue?vue&type=style&index=0&id=4e560f5c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e560f5c"]])

export default __exports__